import { render, staticRenderFns } from "./installmenttable.vue?vue&type=template&id=7b1dd2af&scoped=true&"
import script from "./installmenttable.vue?vue&type=script&lang=js&"
export * from "./installmenttable.vue?vue&type=script&lang=js&"
import style0 from "./installmenttable.vue?vue&type=style&index=0&id=7b1dd2af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1dd2af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
